import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { en } from './en';
import { nl } from './nl';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: en,
  nl: nl,
};

i18n
  .use(LanguageDetector) // browser language detection
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: Object.keys(resources),
    detection: {
      order: ['localStorage', 'navigator'], // detection order
      caches: ['localStorage'], // save setting in localStorage
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;

export const translate = (key: string, options?: Record<string, any>) =>
  i18n.t(key, options);
